// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2IvrN","errorLogs":"styles_errorLogs__17qb3"};